import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: 1.5rem 0;
  text-align: center;
  font-size: 0.875rem;
  background-color: ${({ theme }) => theme.bgSecondary};
  border-top: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textSecondary};
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <div className="container">
        <p>&copy; {currentYear} Sähköllä.fi - Kaikki oikeudet pidätetään</p>
      </div>
    </FooterContainer>
  );
};

export default Footer;
